import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HappyPayTopUpService } from '@features/user/services/happy-pay-top-up.service';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { BankService } from '@shared/services/bank.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'fc-user-happy-pay-topup-add-dialog',
  templateUrl: './user-happy-pay-topup-add-dialog.component.html',
  styleUrls: ['./user-happy-pay-topup-add-dialog.component.css'],
})
export class UserHappyPayTopupAddDialogComponent implements OnInit {
  faSpinner = faSpinner;
  faTimes = faTimes;

  topUpForm: FormGroup;
  methodDropdown: any = [];
  isSubmitted: boolean = false;
  loading: boolean = false;
  page: number = 1;

  constructor(
    private happyPayTopUpService: HappyPayTopUpService,
    private bankService: BankService,
    private router: Router,
    public ref: DynamicDialogRef
  ) {
    this.topUpForm = new FormGroup({
      method: new FormControl(0, Validators.required),
      amount: new FormControl(null, [Validators.required, Validators.min(1)]),
      happy_beauty_bank_account_id: new FormControl(null, Validators.required),
      billing_name: new FormControl(null, Validators.required),
      billing_phone: new FormControl(null, Validators.required),
      billing_email: new FormControl(null, [
        Validators.required,
        Validators.email,
      ]),
      billing_country: new FormControl(null, Validators.required),
      billing_state: new FormControl(null, Validators.required),
      billing_city: new FormControl(null, Validators.required),
      billing_address: new FormControl(null, Validators.required),
      billing_postal_code: new FormControl(null, Validators.required),
    });
  }

  ngOnInit(): void {
    this.bankService.getBeautyBookBankAccounts().subscribe((bankAccounts) => {
      if (bankAccounts) {
        this.topUpForm.controls['happy_beauty_bank_account_id'].setValue(
          bankAccounts[0].id
        );
      }
    });
    this.happyPayTopUpService.getHappyPayTopUpMethods().subscribe((methods) => {
      if (methods) {
        for (let method of methods) {
          this.methodDropdown.push({ label: method.name, value: method.id });
        }
      }
      this.topUpForm.patchValue({ method: 21 });
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    const controls = this.topUpForm.controls;
    if (this.page == 1) {
      if (controls['amount'].valid && controls['method'].valid) {
        this.nextPage();
      }
    } else if (this.page == 2) {
      if (
        controls['billing_name'].valid &&
        controls['billing_phone'].valid &&
        controls['billing_email'].valid
      ) {
        this.nextPage();
      }
    }
    if (this.topUpForm.valid) {
      this.loading = true;
      this.happyPayTopUpService
        .addHappyPayTopUp(this.topUpForm.value)
        .subscribe(
          (res) => {
            this.loading = false;
            this.happyPayTopUpService.setNewHpTopupState(res);
            // this.router.navigate(['/user/happy-pay/top-up']);
            this.dismissModal();
          },
          (error) => {
            this.loading = false;
          }
        );
    }
  }

  nextPage() {
    this.isSubmitted = false;
    if (this.page != 3) {
      this.page += 1;
    }
  }

  prevPage() {
    this.isSubmitted = false;
    if (this.page != 1) {
      this.page -= 1;
    }
  }

  dismissModal() {
    if (this.page !== 3) {
      this.prevPage();
    } else {
      this.ref.close();
    }
  }
}
